import React, {useState} from 'react';
import PinboardImages from "../../../../m3/_legacy_components/pinboard/blocks/images";

export function MessageWidgetImages({onOpenLighbox=()=>{},images=[]}) {

    return <PinboardImages openImageViewer={onOpenLighbox} images={images} />
}